// =====================================================
// Chat Launcher - Floating Button with Coin Flip Animation
// =====================================================

import React from 'react';
import { useChatStore } from '../store/chatStore';

const ChatLauncher: React.FC = () => {
  const { isOpen, setIsOpen } = useChatStore();

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  if (isOpen) return null;

  return (
    <button
      onClick={handleClick}
      className="coin-flip-container fixed bottom-4 right-4 z-50
                 w-14 h-14 sm:w-16 sm:h-16
                 rounded-full shadow-lg hover:shadow-xl transition-all duration-300
                 hover:scale-110 active:scale-95 animate-fade-in"
      aria-label="Open chat"
    >
      {/* The rotating inner container */}
      <div className="coin-flip-inner">
        {/* Front face - Chat Icon */}
        <div className="coin-face coin-face-front">
          <svg
            className="w-8 h-8 text-betenbough-gunmetal"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
            />
          </svg>
        </div>

        {/* Back face - Logo with tooltip */}
        <div className="coin-face coin-face-back">
          {/* Tooltip bubble - only visible with logo */}
          <div className="chat-tooltip absolute -top-10 right-0
                          bg-white text-betenbough-gunmetal px-3 py-1 rounded-full
                          shadow-md text-xs font-filson whitespace-nowrap">
            <span className="typing-text">Hi! How can I help?</span>
            {/* Arrow pointing down */}
            <div className="absolute right-5 -bottom-[5px]
                            w-0 h-0 border-l-[5px] border-l-transparent
                            border-r-[5px] border-r-transparent border-t-[5px] border-t-white" />
          </div>
          <img
            src="/ava-logo.png"
            alt="Ava"
            className="w-[90%] h-[90%] object-cover rounded-full"
            onError={(e) => {
              // Fallback to letter "A" if image doesn't load
              e.currentTarget.style.display = 'none';
              const parent = e.currentTarget.parentElement;
              if (parent) {
                const span = document.createElement('span');
                span.className = 'text-betenbough-gunmetal font-bold text-2xl';
                span.textContent = 'A';
                parent.appendChild(span);
              }
            }}
          />
        </div>
      </div>
    </button>
  );
};

export default ChatLauncher;